import { TranslateService } from '@ngx-translate/core'
import { ModalConfirm } from '../models/modal-confirm.model'

/** Carrito: quitar un producto individual */
export const buildConfirmRemoveProduct = (translate: TranslateService): ModalConfirm => ({
  text: translate.instant('Labels.remove-cart'),
  buttomLeft: { class: 'ion-text-uppercase', text: translate.instant('Buttons.put-off') },
  buttomRight: { class: 'ion-text-uppercase', text: translate.instant('Buttons.cancel') },
  backdropDismiss: true
})

/** Promociones: quitar promoción del carrito */
export const buildConfirmRemovePromotion = (translate: TranslateService): ModalConfirm => ({
  text: translate.instant('Labels.are-you-not-promotion'),
  buttomLeft: { class: 'ion-text-uppercase', text: translate.instant('Buttons.put-off') },
  buttomRight: { class: 'ion-text-uppercase', text: translate.instant('Buttons.cancel') },
  backdropDismiss: true
})

/** Histórico: cancelar pedido en curso */
export const buildConfirmCancelOrder = (translate: TranslateService): ModalConfirm => ({
  text: translate.instant('Labels.are-you-sure-cancel-order'),
  buttomLeft: { class: 'ion-text-uppercase', text: translate.instant('Buttons.remove') },
  buttomRight: { class: 'ion-text-uppercase', text: translate.instant('Buttons.close') },
  backdropDismiss: true
})

/** Perfil: cambios sin guardar (canDeactivate guard) */
export const buildUnsavedChangesModal = (
  translate: TranslateService,
  text: string,
  subText: string
): ModalConfirm => ({
  text,
  subText,
  buttomLeft: { class: 'ion-text-uppercase', text: translate.instant('Buttons.leave') },
  buttomRight: { class: 'ion-text-uppercase', text: translate.instant('Buttons.cancel') },
  backdropDismiss: false
})

/** Perfil: actualización exitosa */
export const buildProfileUpdateModal = (
  translate: TranslateService,
  text: string,
  subText: string
): ModalConfirm => ({
  text,
  subText,
  buttomLeft: { class: 'ion-text-uppercase', text: translate.instant('Buttons.accept') },
  buttomRight: null,
  backdropDismiss: false
})

/** Pedido sugerido: salir con cambios sin guardar */
export const buildConfirmLeaveSuggestedOrder = (translate: TranslateService): ModalConfirm => ({
  text: translate.instant('Titles.suggested-order'),
  subText: translate.instant('Labels.are-you-sure-out-changes-lost'),
  buttomLeft: { class: 'ion-text-uppercase', text: translate.instant('Buttons.leave') },
  buttomRight: { class: 'ion-text-uppercase', text: translate.instant('Buttons.cancel') },
  backdropDismiss: true
})

/** Resumen pedido: confirmar edición */
export const buildConfirmEditOrder = (translate: TranslateService): ModalConfirm => ({
  text: translate.instant('Labels.sure-edit-order'),
  buttomLeft: { class: '', text: translate.instant('Buttons.edit') },
  buttomRight: { class: '', text: translate.instant('Buttons.cancel') },
  backdropDismiss: true
})
